import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { route } from 'preact-router';
import { api, authState } from '../../state/auth.js';
import { useTheme } from '../../hooks/useTheme.js';
import { useAuth } from '../../hooks/useAuth.js';
import { setup, loadSetup, routeShown } from '../../state/setup.js';

export default function OnboardingWizard({ onComplete }) {
  const [completing, setCompleting] = useState(false);
  const theme = useTheme();
  const clubName = theme.name || 'je club';
  const auth = useAuth();
  // Wie de club inricht en de route nog niet af heeft, gaat vanuit hier de inrichting in
  const mayInstall = auth.hasPermission('settings', 'update') && !auth.isComplex;
  useEffect(() => { if (mayInstall) loadSetup(); }, [mayInstall]);
  const startSetup = mayInstall && routeShown(setup.value);

  async function handleComplete(next) {
    setCompleting(true);
    try {
      await api('/api/users/onboarding/complete', { method: 'POST' });
      authState.value = { ...authState.value, onboardingCompleted: true };
      onComplete?.();
    } catch {
      authState.value = { ...authState.value, onboardingCompleted: true };
      onComplete?.();
    }
    if (next) route(next);
  }

  return (
    <div style="position:fixed;inset:0;z-index:9000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(0,0,0,0.5);backdrop-filter:blur(4px)">
      <div style="background:var(--color-surface);border-radius:20px;width:100%;max-width:480px;box-shadow:0 24px 80px rgba(0,0,0,0.25);overflow:hidden">

        {/* Top accent */}
        <div style="height:5px;background:var(--color-primary)" />

        {/* Body */}
        <div style="padding:36px 32px 28px;text-align:center">
          <div style="font-size:48px;margin-bottom:16px">👋</div>
          <h2 style="font-size:22px;font-weight:800;margin:0 0 10px;line-height:1.2">
            Welkom op het platform!
          </h2>
          <p style="font-size:14px;line-height:1.75;color:var(--color-text-muted);margin:0 0 28px;max-width:340px;margin-left:auto;margin-right:auto">
            Fijn dat je er bent. Je bent nu ingelogd op het clubportaal van <strong style="color:var(--color-text)">{clubName}</strong>.
          </p>

          {/* Profile callout */}
          <div style="background:var(--color-bg-secondary);border:1px solid var(--color-border);border-radius:14px;padding:18px 20px;text-align:left;position:relative">
            {/* Arrow pointing to top-right */}
            <div style="position:absolute;top:-10px;right:20px;width:0;height:0;border-left:8px solid transparent;border-right:8px solid transparent;border-bottom:10px solid var(--color-border)" />
            <div style="position:absolute;top:-8px;right:21px;width:0;height:0;border-left:7px solid transparent;border-right:7px solid transparent;border-bottom:9px solid var(--color-bg-secondary)" />

            <div style="display:flex;align-items:center;gap:14px">
              <div style="width:44px;height:44px;border-radius:12px;background:var(--color-primary);display:flex;align-items:center;justify-content:center;font-size:22px;flex-shrink:0">
                👤
              </div>
              <div>
                <div style="font-size:14px;font-weight:700;margin-bottom:3px">Stel je profiel in</div>
                <div style="font-size:13px;color:var(--color-text-muted);line-height:1.5">
                  Klik op jouw avatar <strong style="color:var(--color-text)">rechtsboven</strong> om je naam, foto en voorkeuren in te vullen.
                </div>
              </div>
            </div>
          </div>

          {/* Inrichten: voor wie de club inricht, zolang dat nog niet af is */}
          {startSetup && (
            <div style="background:var(--color-bg-secondary);border:1px solid var(--color-border);border-radius:14px;padding:18px 20px;text-align:left;margin-top:12px;display:flex;align-items:center;gap:14px">
              <div style="width:44px;height:44px;border-radius:12px;background:var(--color-primary);display:flex;align-items:center;justify-content:center;font-size:22px;flex-shrink:0">
                🧭
              </div>
              <div>
                <div style="font-size:14px;font-weight:700;margin-bottom:3px">Jij richt {clubName} in</div>
                <div style="font-size:13px;color:var(--color-text-muted);line-height:1.5">
                  De app neemt je stap voor stap mee: wat je inricht, waarom, en voorbeelden die je zo kunt overnemen.
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div style="padding:0 32px 28px;display:flex;flex-direction:column;align-items:center;gap:10px">
          <button
            onClick={() => handleComplete(startSetup ? '/inrichten' : null)}
            disabled={completing}
            style={`padding:12px 36px;border-radius:12px;border:none;background:var(--color-primary);color:#fff;font-size:15px;font-weight:600;cursor:pointer;transition:opacity .15s;opacity:${completing ? 0.7 : 1};width:100%`}
          >
            {completing ? 'Laden...' : startSetup ? 'Start de inrichting' : 'Aan de slag!'}
          </button>
          {startSetup && (
            <button onClick={() => handleComplete(null)} disabled={completing}
              style="border:none;background:none;color:var(--color-text-muted);font-size:13px;cursor:pointer;padding:4px">
              Eerst zelf rondkijken
            </button>
          )}
        </div>

      </div>
    </div>
  );
}
